import { AppState } from "../models";

const STORAGE_KEY = "bab-chart-state";
const USER_UUID_KEY = "bab-user-uuid";

/**
 * Saves the current application state to LocalStorage.
 */
export function saveToLocal(state: AppState) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch (e) {
    console.error("Failed to save state to LocalStorage", e);
  }
}

/**
 * Returns the persistent user UUID, creating and storing one on first call.
 */
export function getOrCreateUserUUID(): string {
  try {
    const stored = localStorage.getItem(USER_UUID_KEY);
    if (stored) return stored;
    const id = crypto.randomUUID();
    localStorage.setItem(USER_UUID_KEY, id);
    return id;
  } catch {
    return crypto.randomUUID();
  }
}

/**
 * Loads the application state from LocalStorage.
 */
export function loadFromLocal(): AppState | null {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) return null;
    const raw = JSON.parse(saved);
    if (!raw || !Array.isArray(raw.datasets)) return null;
    return raw as AppState;
  } catch (e) {
    console.error("Failed to load state from LocalStorage", e);
    return null;
  }
}
